import type { Fee, GetFeesResponse } from "./ddc-pages-fee-manager-interface";

export const mockNewFees: Fee[] = [
  {
    id: "n1",
    name: "Documentation Fee",
    amount: 299,
    removed: false,
    type: "NEW"
  },
  {
    id: "n2",
    name: "Dealer Preparation",
    amount: 500,
    removed: false,
    type: "NEW"
  },
  {
    id: "n3",
    name: "Extended Warranty",
    amount: 1200,
    removed: false,
    type: "NEW"
  },
  {
    id: "n4",
    name: "Destination Charge",
    amount: 1095,
    removed: false,
    type: "NEW"
  },
  {
    id: "n5",
    name: "Paint Protection",
    amount: 599,
    removed: false,
    type: "NEW"
  },
  {
    id: "n6",
    name: "Fabric Protection",
    amount: 395,
    removed: false,
    type: "NEW"
  },
  {
    id: "n7",
    name: "Window Tinting",
    amount: 450,
    removed: false,
    type: "NEW"
  }
];

export const mockUsedFees: Fee[] = [
  {
    id: "p1",
    name: "Documentation Fee",
    amount: 299,
    removed: false,
    type: "USED"
  },
  {
    id: "p2",
    name: "Reconditioning Fee",
    amount: 895,
    removed: false,
    type: "USED"
  },
  {
    id: "p3",
    name: "Certification Fee",
    amount: 1499,
    removed: false,
    type: "USED"
  },
  {
    id: "p4",
    name: "Title and Registration",
    amount: 275,
    removed: false,
    type: "USED"
  },
  {
    id: "p5",
    name: "Vehicle Inspection",
    amount: 150,
    removed: false,
    type: "USED"
  },
  {
    id: "p6",
    name: "Detail Package",
    amount: 250,
    removed: false,
    type: "USED"
  },
  {
    id: "p7",
    name: "GAP Insurance",
    amount: 795,
    removed: false,
    type: "USED"
  }
];

export const mockAllFees: Fee[] = [...mockNewFees, ...mockUsedFees];

export const mockGetFeesResponse: GetFeesResponse = {
  fees: mockAllFees
};
